import {gql} from '@apollo/client';

export const EDIT_PRINTER = gql`
    mutation updatePrinter($printerId: ID!, $input: PrinterUpdateInput!){
        updatePrinter(printerId: $printerId, input: $input){
            _id
            name
            brand
            images
            length
            width
            height
            weight
            images
            featuredImage
            supportedFiles
            ownerId
        }
    }
`